"use strict";

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);

/**
 * Utility class to manipulate and alter 'Valeur' and 'Montant' types.
 *
 * @see `ValeurHelper.java`
 */
ngModule.factory("valeurUtils", function () {
  var mergeType = function mergeType(typeA, typeB) {
    if (typeA === 'SIMULE' || typeB === 'SIMULE') {
      return 'SIMULE';
    }
    if (typeA === 'ESTIME' || typeB === 'ESTIME') {
      return 'ESTIME';
    }
    if (typeA === 'MANUEL' || typeB === 'MANUEL') {
      return 'MANUEL';
    }
    return 'CONNU';
  };
  return {
    addValeur: function addValeur(a, b) {
      if (a == null) {
        return b;
      }
      if (b == null) {
        return a;
      }
      return {
        valeur: a.valeur + b.valeur,
        type: mergeType(a.type, b.type)
      };
    },
    /**
     * Additionne les montant donnés
     *
     * Retourne la somme, ou `null` si les montants n'ont pas la même devise
     */
    addMontant: function addMontant(a, b) {
      if (a == null) {
        return b;
      }
      if (b == null) {
        return a;
      }
      if (a.devise !== b.devise) {
        return null;
      }
      return {
        devise: a.devise,
        valeur: a.valeur + b.valeur,
        type: mergeType(a.type, b.type)
      };
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/core/utils/valeurUtils.js
// module id = 2768
// module chunks = 13